import {
  BUDGET_QUIZ_INTERFACE,
  CUSTOMER_FORM_QUIZ_INTERFACE,
  DEFAULT_QUIZ_INTERFACE,
  MAKE_MODEL_SELECTION_QUIZ_INTERFACE,
  INVENTORY_SEARCH_QUIZ_INTERFACE,
  CONDITIONAL_INPUT_QUIZ_INTERFACE,
} from "../../constants/quizInterfaces";
import {
  minimumOptionsSelected,
  isAnsweredWithBudget,
  isAnsweredWithMakeModel,
  isAnsweredWithInput,
  isAnsweredWithUserInfoPhoneAndEmail,
} from "../../utils/quiz-selection-count";
import {
  allChildrenAnswered,
  childrenAnsweredOptional,
  oneChildrenAnswered,
} from "../../utils/quiz-view-tracker";
import {
  BUDGET_QUESTION_ID,
  FEATURE_QUESTION_ID,
  IK_IDK_QUESTION_ID,
  LIFESTYLE_QUESTION_ID,
  VEHICLE_POWER_QUESTION_ID,
  VEHICLE_TYPE_QUESTION_ID,
  VEHICLE_CONDITION_QUESTION_ID,
  CUSTOMER_INFO_QUESTION_ID,
  REASON_NEW_VEHICLE_QUESTION_ID,
  TRADE_IN_QUESTION_ID,
  TRADE_IN_PAY_OFF_QUESTION_ID,
  PAYMENT_MODE_QUESTION_ID,
  PICK_CARS_QUESTION_ID,
  IK_IDK_PARENT_QUESTION_ID,
  REASON_NEW_VEHICLE_PARENT_QUESTION_ID,
  VEHICLE_TYPE_PARENT_QUESTION_ID,
  LIFESTYLE_PARENT_QUESTION_ID,
  FEATURE_PARENT_QUESTION_ID,
  FINANCE_BUDGET_PARENT_QUESTION_ID,
  PICK_CARS_PARENT_QUESTION_ID,
  CUSTOMER_INFO_PARENT_QUESTION_ID,
  MONTHLY_BUDGET_QUESTION_ID,
  MNB_UPDATE_PROFILE_PARENT_QUESTION_ID,
  SELECTED_VEHICLE_CONFIRMATION_QUESTION_ID,
  CURRENT_CUSTOMER_VEHICLE_QUESTION_ID,
} from "../../constants/questionIds";
import {
  collectResponsesAggregated,
  collectResponsesSeparate,
} from "../../utils/quiz-response-controller";
import { createQuestionViewIndexMapping } from "../../utils/createQuestionViewIndexMapping";
import { FEATURE_MAPPING } from "./quizFeatureMapping";

export const MNBoptionalQuizQuestions = [
  {
    viewText: "Let's start - where are you in your car buying journey?",
    viewSubtext: "",
    isAnswered: allChildrenAnswered,
    visibilityCondition: function () {
      return true;
    },
    visitedOnce: false,
    automaticForward: false,
    responses: collectResponsesSeparate,
    questionViewId: IK_IDK_PARENT_QUESTION_ID,
    children: [
      {
        text: "",
        subtext: "",
        currSelected: [],
        selectionRange: { minimumSelection: 1, maximumSelection: 1 },
        quizInterface: INVENTORY_SEARCH_QUIZ_INTERFACE,
        optionCardsClassname: "quiz__options_cards two_wider_cards",
        optionStyle: "big-image",
        inputCondition: function () {
          return (
            this[questionViewIndexMapping[IK_IDK_PARENT_QUESTION_ID]]
              .children[0].options[0].selected === true
          );
        },
        inputLabel: "Vehicle (Year, Make and Model)",
        inputValue: "",
        inputFromInventory: false,
        avgBaseMSRP: 0,
        inputRequired: false,
        checkInputError: function (_) {
          const currentQuestion =
            this[questionViewIndexMapping[IK_IDK_PARENT_QUESTION_ID]]
              .children[0];
          return !currentQuestion.inputFromInventory;
        },
        inputErrorMessage: "Kindly choose an option from the dropdown list.",
        inputError: false,
        isAnswered: isAnsweredWithInput,
        childQuestionId: IK_IDK_QUESTION_ID,
        options: [
          {
            text: "I know what I want",
            subtext: "",
            greyicon: "ik.svg",
            selected: false,
          },
          {
            text: "I don’t know just yet",
            subtext: "",
            greyicon: "idk.svg",
            selected: false,
          },
        ],
      },
    ],
  },
  {
    viewText: "Confirmation Page Questions",
    viewSubtext: "",
    isAnswered: allChildrenAnswered,
    visibilityCondition: function () {
      return false;
    },
    visitedOnce: false,
    automaticForward: false,
    responses: collectResponsesSeparate,
    questionViewId: MNB_UPDATE_PROFILE_PARENT_QUESTION_ID,
    children: [
      {
        text: "Is this the right vehicle and trim for you?",
        subtext: "",
        currSelected: [],
        selectionRange: { minimumSelection: 1, maximumSelection: 1 },
        quizInterface: DEFAULT_QUIZ_INTERFACE,
        optionCardsClassname: "two_cards quiz__options_cards",
        isAnswered: minimumOptionsSelected,
        childQuestionId: SELECTED_VEHICLE_CONFIRMATION_QUESTION_ID,
        options: [
          { text: "Yes", selected: false },
          { text: "No", selected: false },
        ],
      },
      {
        text: "What are you currently driving?",
        subtext: "",
        currSelected: [],
        quizInterface: CONDITIONAL_INPUT_QUIZ_INTERFACE,
        optionCardsClassname: "three_cards quiz__options_cards",
        selectionRange: { minimumSelection: 0, maximumSelection: 0 },
        inputCondition: function () {
          return true;
        },
        inputLabel: "Vehicle (Year, Make, Model)",
        inputValue: "",
        isAnswered: isAnsweredWithInput,
        childQuestionId: CURRENT_CUSTOMER_VEHICLE_QUESTION_ID,
        options: [],
      },
    ],
  },
  {
    viewText: "Why are you looking for a new car?",
    viewSubtext: "",
    isAnswered: childrenAnsweredOptional,
    visibilityCondition: function () {
      return true;
    },
    visitedOnce: false,
    automaticForward: false,
    responses: collectResponsesAggregated,
    questionViewId: REASON_NEW_VEHICLE_PARENT_QUESTION_ID,
    questionId: REASON_NEW_VEHICLE_QUESTION_ID,
    children: [
      {
        text: "Other reasons? Who is it for?",
        subtext: "",
        currSelected: [],
        selectionRange: { minimumSelection: 0, maximumSelection: 0 },
        quizInterface: CONDITIONAL_INPUT_QUIZ_INTERFACE,
        optionCardsClassname: "four_cards quiz__options_cards",
        optionStyle: "feature-card",
        inputCondition: function () {
          return true;
        },
        inputLabel: "Notes:",
        inputValue: "",
        isAnswered: isAnsweredWithInput,
      },
    ],
  },
  {
    viewText: "What type of vehicle are you looking for?",
    viewSubtext: "",
    isAnswered: childrenAnsweredOptional,
    visibilityCondition: function () {
      return (
        this[questionViewIndexMapping[IK_IDK_PARENT_QUESTION_ID]].children[0]
          .options[1].selected === true ||
        (this[questionViewIndexMapping[IK_IDK_PARENT_QUESTION_ID]].children[0]
          .options[0].selected === true &&
          !this[questionViewIndexMapping[IK_IDK_PARENT_QUESTION_ID]].children[0]
            .inputFromInventory)
      );
    },
    visitedOnce: false,
    automaticForward: false,
    responses: collectResponsesSeparate,
    questionViewId: VEHICLE_TYPE_PARENT_QUESTION_ID,
    children: [
      {
        text: "New or Pre-Owned car?",
        subtext: "",
        selectionRange: { minimumSelection: 1, maximumSelection: 2 },
        currSelected: [],
        quizInterface: DEFAULT_QUIZ_INTERFACE,
        optionCardsClassname: "two_cards quiz__options_cards",
        optionStyle: "",
        inputCondition: null,
        inputLabel: "",
        inputValue: "",
        isAnswered: minimumOptionsSelected,
        childQuestionId: VEHICLE_CONDITION_QUESTION_ID,
        options: [
          {
            text: "New",
            subtext: "",
            greyicon: "quiz-new.svg",
            selected: false,
          },
          {
            text: "Pre-Owned",
            subtext: "",
            greyicon: "quiz-old.svg",
            selected: false,
          },
        ],
      },
      {
        text: "Which type of vehicle best suits your needs?",
        subtext: "",
        currSelected: [],
        selectionRange: { minimumSelection: 1, maximumSelection: 2 },
        quizInterface: DEFAULT_QUIZ_INTERFACE,
        optionCardsClassname: "four_cards quiz__options_cards",
        optionStyle: "",
        inputCondition: null,
        inputLabel: "",
        inputValue: "",
        isAnswered: minimumOptionsSelected,
        childQuestionId: VEHICLE_TYPE_QUESTION_ID,
        options: [
          {
            text: "Car",
            subtext: "",
            greyicon: "quiz-car-grey.svg",
            selected: false,
          },
          {
            text: "Small SUV",
            subtext: "",
            greyicon: "quiz-suv-grey.svg",
            selected: false,
          },
          {
            text: "Medium SUV",
            subtext: "",
            greyicon: "quiz-suv-grey.svg",
            selected: false,
          },
          {
            text: "Large SUV",
            subtext: "",
            greyicon: "quiz-suv-grey.svg",
            selected: false,
          },
          {
            text: "Minivan",
            subtext: "",
            greyicon: "quiz-minivan-grey.svg",
            selected: false,
          },
          {
            text: "Truck",
            subtext: "",
            greyicon: "quiz-truck.svg",
            selected: false,
          },
        ],
      },
      {
        text: "How do you want your vehicle powered?",
        subtext: "Select your most preferred power type",
        currSelected: [],
        selectionRange: { minimumSelection: 1, maximumSelection: 2 },
        quizInterface: DEFAULT_QUIZ_INTERFACE,
        optionCardsClassname: "three_cards quiz__options_cards",
        isAnswered: minimumOptionsSelected,
        optionStyle: "",
        inputCondition: null,
        inputLabel: "",
        childQuestionId: VEHICLE_POWER_QUESTION_ID,
        options: [
          {
            text: "Gasoline",
            subtext: "",
            greyicon: "quiz-gas-grey.svg",
            selected: false,
          },
          {
            text: "Hybrid",
            subtext: "",
            greyicon: "quiz-hybrid-grey.svg",
            selected: false,
          },
          {
            text: "Plug-in Hybrid",
            subtext: "",
            greyicon: "quiz-plugin-grey.svg",
            selected: false,
          },
          {
            text: "Electric",
            subtext: "",
            greyicon: "quiz-ev-grey.svg",
            selected: false,
          },
          {
            text: "Diesel",
            subtext: "",
            greyicon: "quiz-diesel-grey.svg",
            selected: false,
          },
        ],
      },
      {
        text: "What's your budget?",
        subtext: "Monthly or Range",
        visibilityCondition: function () {
          return (
            this[questionViewIndexMapping[IK_IDK_PARENT_QUESTION_ID]]
              .children[0].options[1].selected === true ||
            (this[questionViewIndexMapping[IK_IDK_PARENT_QUESTION_ID]]
              .children[0].options[0].selected === true &&
              !this[questionViewIndexMapping[IK_IDK_PARENT_QUESTION_ID]]
                .children[0].inputFromInventory)
          );
        },
        currSelected: [],
        selectionRange: { minimumSelection: 1, maximumSelection: 1 },
        minBudget: "",
        maxBudget: "",
        monthlyBudget: "",
        quizInterface: BUDGET_QUIZ_INTERFACE,
        optionCardsClassname: "four_cards quiz__options_cards",
        optionStyle: "",
        inputCondition: null,
        inputLabel: "",
        inputValue: "",
        isAnswered: isAnsweredWithBudget,
        responses: function () {
          return [
            ...this.currSelected,
            this.currSelected.length > 0
              ? this.monthlyBudget
                ? "monthly"
                : "range"
              : null,
          ].filter(Boolean);
        },
        childQuestionId: BUDGET_QUESTION_ID,
      },
    ],
  },
  {
    viewText: "What are some of your must-have features?",
    viewSubtext: "Select any that are important to you",
    isAnswered: childrenAnsweredOptional,
    visibilityCondition: function () {
      return true;
    },
    visitedOnce: false,
    automaticForward: false,
    responses: function () {
      const featureOptions = {};

      this.children.forEach((child) => {
        child.options.forEach((option) => {
          if (option.featureKey) {
            featureOptions[option.featureKey] = option.selected;
          }
        });
      });

      return {
        question: this.viewText,
        selectedOptions: [featureOptions],
        inputValue:
          this.children.find(
            (childQuestion) => childQuestion.inputValue?.length > 0
          )?.inputValue || "",
        questionId: this.questionId,
      };
    },
    questionViewId: FEATURE_PARENT_QUESTION_ID,
    questionId: FEATURE_QUESTION_ID,
    children: [
      {
        text: "Drivetrain",
        subtext: "",
        currSelected: [],
        selectionRange: { minimumSelection: 1, maximumSelection: 2 },
        quizInterface: DEFAULT_QUIZ_INTERFACE,
        optionCardsClassname: "two_cards quiz__options_cards",
        optionStyle: "feature-card",
        isAnswered: minimumOptionsSelected,
        options: [
          JSON.parse(JSON.stringify(FEATURE_MAPPING["AWD"])),
          JSON.parse(JSON.stringify(FEATURE_MAPPING["FWD"])),
        ],
      },
      {
        text: "Seats",
        subtext: "",
        currSelected: [],
        selectionRange: { minimumSelection: 1, maximumSelection: 1 },
        quizInterface: DEFAULT_QUIZ_INTERFACE,
        optionCardsClassname: "two_cards quiz__options_cards",
        optionStyle: "feature-card",
        isAnswered: minimumOptionsSelected,
        options: [
          JSON.parse(JSON.stringify(FEATURE_MAPPING["leather"])),
          JSON.parse(JSON.stringify(FEATURE_MAPPING["cloth"])),
        ],
      },
      {
        text: "Colors",
        subtext: "",
        currSelected: [],
        selectionRange: { minimumSelection: 1, maximumSelection: 9 },
        quizInterface: DEFAULT_QUIZ_INTERFACE,
        optionCardsClassname: "four_cards quiz__options_cards",
        optionStyle: "feature-card",
        isAnswered: minimumOptionsSelected,
        options: [
          JSON.parse(JSON.stringify(FEATURE_MAPPING["blackColor"])),
          JSON.parse(JSON.stringify(FEATURE_MAPPING["whiteColor"])),
          JSON.parse(JSON.stringify(FEATURE_MAPPING["greyColor"])),
          JSON.parse(JSON.stringify(FEATURE_MAPPING["blueColor"])),
          JSON.parse(JSON.stringify(FEATURE_MAPPING["redColor"])),
          JSON.parse(JSON.stringify(FEATURE_MAPPING["greenColor"])),
          JSON.parse(JSON.stringify(FEATURE_MAPPING["orangeColor"])),
          JSON.parse(JSON.stringify(FEATURE_MAPPING["brownAndGoldColor"])),
          JSON.parse(JSON.stringify(FEATURE_MAPPING["otherColor"])),
        ],
      },
      {
        text: "Sunroof",
        subtext: "",
        currSelected: [],
        selectionRange: { minimumSelection: 1, maximumSelection: 1 },
        quizInterface: DEFAULT_QUIZ_INTERFACE,
        optionCardsClassname: "two_cards quiz__options_cards",
        optionStyle: "feature-card",
        isAnswered: minimumOptionsSelected,
        options: [
          JSON.parse(JSON.stringify(FEATURE_MAPPING["sunroof"])),
          JSON.parse(JSON.stringify(FEATURE_MAPPING["noSunroof"])),
        ],
      },
      {
        text: "Number of Seats",
        subtext: "",
        currSelected: [0],
        selectionRange: { minimumSelection: 1, maximumSelection: 1 },
        quizInterface: DEFAULT_QUIZ_INTERFACE,
        optionCardsClassname: "two_cards quiz__options_cards",
        optionStyle: "feature-card",
        isAnswered: minimumOptionsSelected,
        options: [
          JSON.parse(JSON.stringify(FEATURE_MAPPING["fiveSeats"])),
          JSON.parse(JSON.stringify(FEATURE_MAPPING["sixSeats"])),
          JSON.parse(JSON.stringify(FEATURE_MAPPING["sevenSeats"])),
          JSON.parse(JSON.stringify(FEATURE_MAPPING["eightSeats"])),
        ],
      },
      {
        text: "Other Important Features?",
        subtext: "Fully Loaded or Basic?",
        currSelected: [],
        selectionRange: { minimumSelection: 1, maximumSelection: 7 },
        quizInterface: CONDITIONAL_INPUT_QUIZ_INTERFACE,
        optionCardsClassname: "three_cards quiz__options_cards",
        optionStyle: "feature-card",
        inputCondition: function () {
          return true;
        },
        inputLabel: "Notes",
        inputValue: "",
        isAnswered: minimumOptionsSelected,
        options: [
          JSON.parse(JSON.stringify(FEATURE_MAPPING["heatedSeats"])),
          JSON.parse(JSON.stringify(FEATURE_MAPPING["heatedSteeringWheel"])),
          JSON.parse(
            JSON.stringify(FEATURE_MAPPING["keylessEntryAndPushStart"])
          ),
          JSON.parse(JSON.stringify(FEATURE_MAPPING["seatMemory"])),
          JSON.parse(JSON.stringify(FEATURE_MAPPING["powerSeats"])),
          JSON.parse(
            JSON.stringify(FEATURE_MAPPING["appleCarPlayAndroidAuto"])
          ),
          JSON.parse(JSON.stringify(FEATURE_MAPPING["powerLiftgate"])),
        ],
      },
    ],
  },
  {
    viewText: "What's your lifestyle?",
    viewSubtext:
      "Let us find a car that best matches your day to day needs and aligns with what’s important to you.",
    isAnswered: oneChildrenAnswered,
    visibilityCondition: function () {
      return false;
    },
    visitedOnce: false,
    automaticForward: false,
    responses: collectResponsesAggregated,
    questionId: LIFESTYLE_QUESTION_ID,
    questionViewId: LIFESTYLE_PARENT_QUESTION_ID,
    children: [
      {
        text: "Colors",
        subtext: "",
        currSelected: [],
        selectionRange: { minimumSelection: 0, maximumSelection: 9 },
        quizInterface: DEFAULT_QUIZ_INTERFACE,
        optionCardsClassname: "four_cards quiz__options_cards",
        optionStyle: "feature-card",
        inputCondition: null,
        inputLabel: "",
        inputValue: "",
        isAnswered: minimumOptionsSelected,
        options: [
          {
            text: "⚫ Black",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "⚪ White",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "🔘 Grey",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "🔵 Blue",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "🔴 Red",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "🟢 Green",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "🟠 Orange",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "🟤 Brown/Gold",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "Other Colour",
            subtext: "",
            selected: false,
            greyicon: "",
          },
        ],
      },
      {
        text: "Family",
        subtext: "",
        currSelected: [],
        selectionRange: { minimumSelection: 0, maximumSelection: 8 },
        quizInterface: DEFAULT_QUIZ_INTERFACE,
        optionCardsClassname: "four_cards quiz__options_cards",
        optionStyle: "feature-card",
        inputCondition: null,
        inputLabel: "",
        inputValue: "",
        isAnswered: minimumOptionsSelected,
        options: [
          {
            text: "👨🏻 Tall Family Members",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "🐶 Large Dog",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "🛞 Multiple Main Drivers",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "👶🏻 1-2 Kids",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "👶🏻 3-4 Kids",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "👶🏻 5+ Kids",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "👵🏻 Older Family Members",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "🆕 New Driver",
            subtext: "",
            selected: false,
            greyicon: "",
          },
        ],
      },
      {
        text: "Outdoors and Equipment",
        subtext: "",
        currSelected: [],
        selectionRange: { minimumSelection: 0, maximumSelection: 9 },
        quizInterface: DEFAULT_QUIZ_INTERFACE,
        optionCardsClassname: "four_cards quiz__options_cards",
        optionStyle: "feature-card",
        inputCondition: null,
        inputLabel: "",
        inputValue: "",
        isAnswered: minimumOptionsSelected,
        options: [
          {
            text: "💺 Car Seat(s)",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "⛳ Golfing",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "⛷️ Skiing/Snowboarding",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "🚴🏻 Biking",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "😴 Car Sleeping",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "🏕️ Camping",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "🛶 Canoe/Kayak",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "⚽ Sports Practices",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "🏊 Water Sports",
            subtext: "",
            selected: false,
            greyicon: "",
          },
        ],
      },
      {
        text: "Towing",
        subtext: "",
        currSelected: [],
        selectionRange: { minimumSelection: 0, maximumSelection: 4 },
        quizInterface: DEFAULT_QUIZ_INTERFACE,
        optionCardsClassname: "four_cards quiz__options_cards",
        optionStyle: "feature-card",
        inputCondition: null,
        inputLabel: "",
        inputValue: "",
        isAnswered: minimumOptionsSelected,
        options: [
          {
            text: "Trailer",
            subtext: "",
            selected: false,
            greyicon: "van.png",
          },
          {
            text: "🛥️ Boat",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "🏕️ Camper",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "🚧 Construction",
            subtext: "",
            selected: false,
            greyicon: "",
          },
        ],
      },
      {
        text: "Driving Geography",
        subtext: "",
        currSelected: [],
        selectionRange: { minimumSelection: 0, maximumSelection: 6 },
        quizInterface: DEFAULT_QUIZ_INTERFACE,
        optionCardsClassname: "four_cards quiz__options_cards",
        optionStyle: "feature-card",
        inputCondition: null,
        inputLabel: "",
        inputValue: "",
        isAnswered: minimumOptionsSelected,
        options: [
          {
            text: "Off Roading",
            subtext: "",
            selected: false,
            greyicon: "jeep.png",
          },
          {
            text: "❄️ Snow",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "⛰️ Steep/Hilly Roads",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "🏎️ Sporty Driving",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "🏙️ Lots of City/Traffic",
            subtext: "",
            selected: false,
            greyicon: "",
          },
          {
            text: "🛣️ Lots of Highway Driving",
            subtext: "",
            selected: false,
            greyicon: "",
          },
        ],
      },
    ],
  },
  {
    viewText: "Finances and Budget",
    viewSubtext: "",
    isAnswered: allChildrenAnswered,
    visibilityCondition: function () {
      return false;
    },
    visitedOnce: false,
    automaticForward: false,
    responses: collectResponsesSeparate,
    questionViewId: FINANCE_BUDGET_PARENT_QUESTION_ID,
    children: [
      {
        text: "Are you planning on keeping it?",
        subtext: "",
        currSelected: [],
        selectionRange: { minimumSelection: 1, maximumSelection: 1 },
        quizInterface: CONDITIONAL_INPUT_QUIZ_INTERFACE,
        optionCardsClassname: "three_cards quiz__options_cards",
        isAnswered: isAnsweredWithInput,
        optionStyle: "",
        childQuestionId: TRADE_IN_QUESTION_ID,
        inputCondition: function () {
          return (
            this[questionViewIndexMapping[FINANCE_BUDGET_PARENT_QUESTION_ID]]
              .children[0].options[0].selected === true
          );
        },
        inputLabel: "Notes (Kms, Current Payment, Payoff $, Lienholder)",
        inputValue: "",
        inputRequired: false,
        inputError: false,
        inputErrorMessage: "",
        checkInputError: function (text) {
          return !text;
        },
        options: [
          { text: "Yes", selected: false },
          { text: "No", selected: false },
          { text: "Haven’t decided", selected: false },
        ],
      },
      {
        text: "Is your car paid off?",
        subtext: "",
        selectionRange: { minimumSelection: 1, maximumSelection: 1 },
        currSelected: [],
        optionCardsClassname: "three_cards quiz__options_cards",
        quizInterface: CONDITIONAL_INPUT_QUIZ_INTERFACE,
        optionStyle: "",
        visibilityCondition: function () {
          return (
            this[questionViewIndexMapping[FINANCE_BUDGET_PARENT_QUESTION_ID]]
              .children[0].options[0].selected === true ||
            this[questionViewIndexMapping[FINANCE_BUDGET_PARENT_QUESTION_ID]]
              .children[0].options[2].selected === true
          );
        },
        inputCondition: function () {
          return (
            this[questionViewIndexMapping[FINANCE_BUDGET_PARENT_QUESTION_ID]]
              .children[0].options[0].selected === true ||
            this[questionViewIndexMapping[FINANCE_BUDGET_PARENT_QUESTION_ID]]
              .children[0].options[2].selected === true
          );
        },
        inputLabel:
          "Trade-in Notes (Kms, Current Payment, Payoff $, Lienholder)",
        inputValue: "",
        inputRequired: false,
        checkInputError: function (text) {
          return false;
        },
        inputError: false,
        inputErrorMessage: "",
        required: true,
        isAnswered: minimumOptionsSelected,
        childQuestionId: TRADE_IN_PAY_OFF_QUESTION_ID,
        options: [
          {
            text: "Yes",
            subtext: "",
            greyicon: "",
            selected: false,
          },
          {
            text: "No",
            subtext: "",
            greyicon: "",
            selected: false,
          },
        ],
      },
      {
        text: "Are you interested in buying Cash or Financing or Leasing?",
        subtext: "",
        selectionRange: { minimumSelection: 1, maximumSelection: 3 },
        currSelected: [],
        optionCardsClassname: "three_cards quiz__options_cards",
        quizInterface: CONDITIONAL_INPUT_QUIZ_INTERFACE,
        optionStyle: "",
        inputCondition: function () {
          return (
            this[questionViewIndexMapping[FINANCE_BUDGET_PARENT_QUESTION_ID]]
              .children[2].options[1].selected === true ||
            this[questionViewIndexMapping[FINANCE_BUDGET_PARENT_QUESTION_ID]]
              .children[2].options[2].selected === true
          );
        },
        inputLabel: "Downpayment",
        inputValue: "",
        inputRequired: true,
        inputErrorMessage: "Enter only Numeric Values",
        checkInputError: function (text) {
          return !text || isNaN(text);
        },
        inputError: false,
        isAnswered: isAnsweredWithInput,
        childQuestionId: PAYMENT_MODE_QUESTION_ID,
        options: [
          {
            text: "Cash",
            subtext: "",
            greyicon: "Quiz-Cash.svg",
            selected: false,
          },
          {
            text: "Finance",
            subtext: "",
            greyicon: "Quiz-Finance.svg",
            selected: false,
          },
          {
            text: "Lease",
            subtext: "",
            greyicon: "Quiz-Lease.svg",
            selected: false,
          },
        ],
      },
      {
        text: "What's your budget?",
        subtext: "Monthly",
        visibilityCondition: function () {
          return (
            // this[questionViewIndexMapping[IK_IDK_PARENT_QUESTION_ID]].children[0]
            //   .options[1].selected === false &&
            this[questionViewIndexMapping[IK_IDK_PARENT_QUESTION_ID]]
              .children[0].options[0].selected === true &&
            this[questionViewIndexMapping[IK_IDK_PARENT_QUESTION_ID]]
              .children[0].inputFromInventory
          );
        },
        currSelected: [],
        selectionRange: { minimumSelection: 1, maximumSelection: 1 },
        minBudget: "",
        maxBudget: "",
        monthlyBudget: "",
        quizInterface: BUDGET_QUIZ_INTERFACE,
        optionCardsClassname: "four_cards quiz__options_cards",
        optionStyle: "",
        inputCondition: null,
        inputLabel: "",
        inputValue: "",
        isAnswered: function () {
          return true;
        },
        responses: function () {
          return [
            ...this.currSelected,
            this.currSelected.length > 0 ? "monthly" : null,
          ].filter(Boolean);
        },
        childQuestionId: MONTHLY_BUDGET_QUESTION_ID,
      },
    ],
  },
  {
    viewText: "What other cars are you exploring?",
    viewSubtext:
      "Mae’s concierge can build you an unbiased comparison chart to make clear and fast decisions.",
    isAnswered: allChildrenAnswered,
    visibilityCondition: function () {
      return false;
    },

    visitedOnce: false,
    automaticForward: false,
    responses: function () {
      const allFilledCars = this.children[0].currSelected.filter(
        (makeAndModelObj) => {
          return makeAndModelObj.make && makeAndModelObj.model;
        }
      );
      return {
        question: this.viewText,
        selectedOptions: allFilledCars,
        questionId: this.children[0].childQuestionId,
      };
    },
    questionViewId: PICK_CARS_PARENT_QUESTION_ID,
    children: [
      {
        text: "",
        subtext: "",
        selectionRange: { minimumSelection: 1, maximumSelection: 5 },
        currSelected: [{ make: "", model: "" }],
        noOfCarsAdded: 0,
        quizInterface: MAKE_MODEL_SELECTION_QUIZ_INTERFACE,
        optionCardsClassname: "four_cards quiz__options_cards",
        optionStyle: "",
        inputCondition: null,
        inputLabel: "",
        inputValue: "",
        isAnswered: isAnsweredWithMakeModel,
        childQuestionId: PICK_CARS_QUESTION_ID,
      },
    ],
  },
  {
    viewText:
      "To complete your personalized check-in, please provide your contact details.",
    viewSubtext: "",
    isAnswered: allChildrenAnswered,
    visibilityCondition: function () {
      return true;
    },
    visitedOnce: false,
    automaticForward: false,
    responses: function () {
      return {
        question: this.viewText,
        selectedOptions: [
          {
            firstName: this.children[0].firstName,
            lastName: this.children[0].lastName,
            phoneNo: this.children[0].phoneNo,
            email: this.children[0].email,
            postalCode: this.children[0].postalCode,
            whereDidYouHereAboutUs: this.children[0].whereDidYouHereAboutUs,
          },
        ],
        questionId: this.children[0].childQuestionId,
      };
    },
    questionViewId: CUSTOMER_INFO_PARENT_QUESTION_ID,
    children: [
      {
        text: "",
        subtext: "",
        selectionRange: { minimumSelection: 4, maximumSelection: 4 },
        currSelected: [],
        firstName: "",
        lastName: "",
        phoneNo: "",
        postalCode: "",
        hasPostalCode: false,
        email: "Not Mentioned",
        whereDidYouHereAboutUs: "",
        salesPersonInfo: "",
        quizInterface: CUSTOMER_FORM_QUIZ_INTERFACE,
        optionCardsClassname: "four_cards quiz__options_cards",
        optionStyle: "",
        inputCondition: null,
        inputLabel: "",
        inputValue: "",
        isAnswered: isAnsweredWithUserInfoPhoneAndEmail,
        childQuestionId: CUSTOMER_INFO_QUESTION_ID,
      },
    ],
  },
];

const questionViewIndexMapping = createQuestionViewIndexMapping(
  MNBoptionalQuizQuestions
);
